import api from "./api";
import {
  ListPermissionsResponse,
  SavePermissionsPayload,
} from "../types/SystemPermission";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export async function findPermissionsByRole(
  roleId: number,
): Promise<ListPermissionsResponse> {
  const response = await api.get<ListPermissionsResponse>("/permissions", {
    params: {
      role_id: roleId,
    },
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function savePermissions(
  payload: SavePermissionsPayload,
): Promise<void> {
  await api.post("/permissions", payload, {
    headers: getAuthHeaders(),
  });
}
